module.exports = __webpack_public_path__ + "img/pas-livraison-icon-2.db711d80.svg";